import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

interface InputProps {
  value: string;
  isError?: boolean;
}

export const Input = styled.input<InputProps>`
  ${({ theme, value, isError }) => css`
    box-sizing: border-box;
    width: 44px;
    height: 56px;
    border: 2px solid ${theme.backgroundColor.divider};
    border-radius: 8px;
    outline: none;
    background: inherit;
    color: ${theme.content.hierarchy1};
    font-size: 24px;
    text-align: center;

    &:focus {
      border: 2px solid ${theme.themeColor.main_1};
    }
    ${value && { border: `2px solid ${theme.themeColor.main_1}` }}
    ${isError && { border: `2px solid ${theme.colors.red300}` }}
    

    /* Chrome, Safari, Edge, Opera */

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */

    &[type='number'] {
      -moz-appearance: textfield;
    }
  `}
`;
